import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance with credentials
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

export const authService = {
  login: () => window.location.href = `${API_URL}/auth/login`,
  orgTokenLogin: async (apiToken) => {
    const response = await apiClient.post('/auth/org-login', {
      apiToken
    });
    return response.data;
  },
  logout: async () => await apiClient.get('/auth/logout'),
  checkAuthStatus: async () => {
    const response = await apiClient.get('/auth/status');
    return response.data;
  },
  getAccountInfo: async () => {
    const response = await apiClient.get('/auth/account');
    return response.data;
  }
};

export const invoiceService = {
  getBillingPeriods: async () => {
    const response = await apiClient.get('/invoices/billing-periods');
    return response.data;
  },
  
  getInvoiceData: async (invoiceId) => {
    const response = await apiClient.get(`/invoices/invoice/${invoiceId}`);
    return response.data;
  },
  
  getBillingInsights: async (accountUrn, startDate, endDate, page = 1, perPage = 100) => {
    const response = await apiClient.get('/invoices/billing-insights', {
      params: {
        account_urn: accountUrn,
        start_date: startDate,
        end_date: endDate,
        page,
        per_page: perPage
      }
    });
    return response.data;
  }
};

export const dropletService = {
  getLiveCosts: async () => {
    const response = await apiClient.get('/droplets/live-costs');
    return response.data;
  },
  
  getDropletNames: async (dropletIds) => {
    const response = await apiClient.post('/droplets/names', { dropletIds });
    return response.data;
  }
};